import {
  PANDA_HELP_LINK,
  US_PANDA_HELP_LINK,
  PANDA_HELP_STORAGE_LINK,
  US_PANDA_HELP_STORAGE_LINK,
  PANDA_HELP_TRAFFIC_LINK,
  US_PANDA_HELP_TRAFFIC_LINK,
  PANDA_HELP_LIVE_LINK,
  US_PANDA_HELP_LIVE_LINK,
  PANDA_HELP_FACEBOOKPIXEL_LINK,
  US_PANDA_HELP_FACEBOOKPIXEL_LINK,
  PANDA_HELP_SAVE_VIDEO_PROGRESS_LINK,
  US_PANDA_HELP_SAVE_VIDEO_PROGRESS_LINK,
  PANDA_HELP_RETENTION_METRICS_LINK,
  US_PANDA_HELP_RETENTION_METRICS_LINK,
  PANDA_PAUSE_THUMBNAIL,
  US_PANDA_PAUSE_THUMBNAIL,
  PANDA_USER_MANAGEMENT,
  US_PANDA_USER_MANAGEMENT,
  PANDA_CREDITS,
  US_PANDA_CREDITS,
  EBOOK_LINK,
  US_EBOOK_LINK,
  MENTALMAP_LINK,
  US_MENTALMAP_LINK,
  AI_SUBTITLES_LINK,
  US_AI_SUBTITLES_LINK,
  QUIZ_LINK,
  US_QUIZ_LINK,
  AI_DUBBING_LINK,
  US_AI_DUBBING_LINK,
  AI_LINK,
  US_AI_LINK,
  SMART_SEARCH_LINK,
  US_SMART_SEARCH_LINK,
  US_VIDEO_SPEED_LINK,
  VIDEO_SPEED_LINK,
} from '@/config/envs.js'

export default {
  methods: {
    getHelpLink() {
      const locale = this.$i18next.resolvedLanguage
      let link = PANDA_HELP_LINK
      if (locale.includes('en')) link = US_PANDA_HELP_LINK
      return link
    },
    getStorageLink() {
      const locale = this.$i18next.resolvedLanguage
      let link = PANDA_HELP_STORAGE_LINK
      if (locale.includes('en')) link = US_PANDA_HELP_STORAGE_LINK
      return link
    },
    getTrafficLink() {
      const locale = this.$i18next.resolvedLanguage
      let link = PANDA_HELP_TRAFFIC_LINK
      if (locale.includes('en')) link = US_PANDA_HELP_TRAFFIC_LINK
      return link
    },
    getLiveLink() {
      const locale = this.$i18next.resolvedLanguage
      let link = PANDA_HELP_LIVE_LINK
      if (locale.includes('en')) link = US_PANDA_HELP_LIVE_LINK
      return link
    },
    getFacebookPixelLink() {
      const locale = this.$i18next.resolvedLanguage
      let link = PANDA_HELP_FACEBOOKPIXEL_LINK
      if (locale.includes('en')) link = US_PANDA_HELP_FACEBOOKPIXEL_LINK
      return link
    },
    getSaveVideoProgressLink() {
      const locale = this.$i18next.resolvedLanguage
      let link = PANDA_HELP_SAVE_VIDEO_PROGRESS_LINK
      if (locale.includes('en')) link = US_PANDA_HELP_SAVE_VIDEO_PROGRESS_LINK
      return link
    },
    getRetentionLink() {
      const locale = this.$i18next.resolvedLanguage
      let link = PANDA_HELP_RETENTION_METRICS_LINK
      if (locale.includes('en')) link = US_PANDA_HELP_RETENTION_METRICS_LINK
      return link
    },
    getPauseThumbnailLink() {
      const locale = this.$i18next.resolvedLanguage
      let link = PANDA_PAUSE_THUMBNAIL
      if (locale.includes('en')) link = US_PANDA_PAUSE_THUMBNAIL
      return link
    },
    getUserManagementLink() {
      const locale = this.$i18next.resolvedLanguage
      let link = PANDA_USER_MANAGEMENT
      if (locale.includes('en')) link = US_PANDA_USER_MANAGEMENT
      return link
    },
    getCreditsLink() {
      const locale = this.$i18next.resolvedLanguage
      let link = PANDA_CREDITS
      if (locale.includes('en')) link = US_PANDA_CREDITS
      return link
    },
    getEbookLink() {
      const locale = this.$i18next.resolvedLanguage
      let link = EBOOK_LINK
      if (locale.includes('en')) link = US_EBOOK_LINK
      return link
    },
    getMindMapLink() {
      const locale = this.$i18next.resolvedLanguage
      let link = MENTALMAP_LINK
      if (locale.includes('en')) link = US_MENTALMAP_LINK
      return link
    },
    getAiSubtitlesLink() {
      const locale = this.$i18next.resolvedLanguage
      let link = AI_SUBTITLES_LINK
      if (locale.includes('en')) link = US_AI_SUBTITLES_LINK
      return link
    },
    getQuizLink() {
      const locale = this.$i18next.resolvedLanguage
      let link = QUIZ_LINK
      if (locale.includes('en')) link = US_QUIZ_LINK
      return link
    },
    getAiDubbingLink() {
      const locale = this.$i18next.resolvedLanguage
      let link = AI_DUBBING_LINK
      if (locale.includes('en')) link = US_AI_DUBBING_LINK
      return link
    },
    getAiHelperLink() {
      const locale = this.$i18next.resolvedLanguage
      let link = AI_LINK
      if (locale.includes('en')) link = US_AI_LINK
      return link
    },
    getSmartSearchLink() {
      const locale = this.$i18next.resolvedLanguage
      let link = SMART_SEARCH_LINK
      if (locale.includes('en')) link = US_SMART_SEARCH_LINK
      return link
    },
    getVideoSpeedLink() {
      const locale = this.$i18next.resolvedLanguage
      let link = VIDEO_SPEED_LINK
      if (locale.includes('en')) link = US_VIDEO_SPEED_LINK
      return link
    },
  },
}
